import React from 'react';

import { SplitBlockAppearance, SplitBlockBlockquote } from 'api/cms';
import { Box } from 'components/Box';
import { BodyLarge, BodySmall } from 'components/Text';
import { colors, gutterWidth } from 'theme';

import { Blockquote } from './Blockquote';

type Props = {
  appearance: SplitBlockAppearance;
  blockId: string;
  section: SplitBlockBlockquote;
  blockIndex: number;
  index: number;
};

export function BlockquoteContent({
  appearance,
  blockId,
  blockIndex,
  index,
  section,
}: Props) {
  const showTextBox = ['FULL_WIDTH', 'OVERLAPPING'].includes(appearance);
  return (
    <Box
      data-qa-id={`split-content-section-${index}`}
      zIndex={showTextBox && 1}
      width={[1, null, 1 / 2]}
      px={[gutterWidth / 4, null, gutterWidth / 2]}
      py={[gutterWidth / 4, null, gutterWidth / 2]}
      key={blockId}
    >
      <Box
        left={[null, null, '50%']}
        top={[null, null, '50%']}
        height="100%"
        width="100%"
        bg={showTextBox ? 'white' : colors.fog}
        boxShadow={showTextBox ? '0 0 6px rgba(0,0,0,0.3)' : null}
        borderRadius={showTextBox ? 12 : 24}
      >
        <Blockquote
          component="blockquote"
          position="relative"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          height="100%"
          m={0}
          p={[gutterWidth / 2, null, gutterWidth]}
        >
          <BodyLarge
            analyticsData={{
              eventName: 'CMS Block',
              eventProperties: {
                block_position: blockIndex,
                block_type: 'Split Content',
              },
            }}
            dangerouslySetInnerHTML={{
              __html: section.data.quote,
            }}
          />
          {section.data.cite && <BodySmall>{section.data.cite}</BodySmall>}
        </Blockquote>
      </Box>
    </Box>
  );
}
